import React from 'react';
import WelcomeBanner from '../features/race/components/WelcomeBanner';

export default function IFConvention2026() {

  return (
    <>
      <WelcomeBanner />
      <div className="container-fluid py-4">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-9">

          <div className="position-relative mb-5 py-4">
            <div className="position-relative text-white text-center py-4 rounded-3 shadow-lg" style={{ background: 'linear-gradient(135deg, #0b3d91 0%, #0a59a1 100%)' }}>
              <h1 className="display-4 mb-2">2026 IF Convention Race</h1>
          </div>
          </div>

          {/* Quick Facts Section */}
          <div className="row mb-4">
            <div className="col-lg-4 mb-3">
              <div className="card h-100 border shadow-sm bg-light">
                <div className="card-body text-center">
                  <div className="display-4 mb-3 text-dark">📅</div>
                  <h4 className="card-title text-dark">When?</h4>
                  <p className="card-text fs-5 mb-0 text-dark">
                    <strong>November 5-7, 2026</strong><br/>
                    <small className="text-muted">November 6 is Race Day (Weather Permitting)</small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mb-3">
              <div className="card h-100 border shadow-sm bg-light">
                <div className="card-body text-center">
                  <div className="display-4 mb-3 text-dark">📍</div>
                  <h4 className="card-title text-dark">Where?</h4>
                  <p className="card-text fs-5 mb-0 text-dark">
                    <strong>Fayette City, PA</strong><br/>
                    <small className="text-muted">300 Miles Distance</small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mb-3">
              <div className="card h-100 border shadow-sm bg-light">
                <div className="card-body text-center">
                  <div className="display-4 mb-3 text-dark">🏆</div>
                  <h4 className="card-title text-dark">Prize?</h4>
                  <p className="card-text fs-5 mb-0 text-dark">
                    <strong>20,000 Points (based on entries)</strong><br/>
                    <small className="text-muted">Top 25 birds will be Auctioned</small>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* How Much Does It Cost? */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light">
              <h3 className="card-title mb-0 text-center" style={{ color: '#0b3d91' }}>
                Entry Options
              </h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-lg-3 col-md-6 mb-3">
                  <div className="border rounded p-3 h-100 text-center bg-white">
                    <div className="h2 text-dark fw-bold">5 Birds</div>
                    <p className="h6 mb-2 text-muted">(1 for rotation)</p>
                    <small className="text-muted">$500</small>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                  <div className="border rounded p-3 h-100 text-center bg-white">
                    <div className="h2 text-dark fw-bold">12 Birds</div>
                    <p className="h6 mb-2 text-muted">(2 for rotation)</p>
                    <small className="text-muted">$1000</small>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                  <div className="border rounded p-3 h-100 text-center bg-white">
                    <div className="h2 text-dark fw-bold">20 Birds</div>
                    <p className="h6 mb-2 text-muted">(2 for rotation)</p>
                    <small className="text-muted">$1500</small>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                  <div className="border rounded p-3 h-100 text-center bg-white">
                    <div className="h2 text-dark fw-bold">30 Birds</div>
                    <p className="h6 mb-2 text-muted">(3 for rotation)</p>
                    <small className="text-muted">$2000</small>
                  </div>
                </div>
              </div>
              <div className="alert alert-warning mt-3">
                <i className="bi bi-info-circle me-2"></i>
                <strong>Important Rules:</strong> Each breeder can only send 5 birds to each handler. No limits on birds you'll just need to send them to other handlers. Based on your entry option, some of your birds will be placed in mandatory rotation. You must pay money when you send your birds. Make check to "Central Jersey Combine".
              </div>
            </div>
          </div>

          {/* Race Areas */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light">
              <h3 className="card-title mb-0 text-center" style={{ color: '#0b3d91' }}>
                🗺️ Race Areas
              </h3>
              <p className="text-center text-muted mb-0 mt-2">Points based on total entrants in each section</p>
            </div>
            <div className="card-body">
              <div className="row text-center">
                <div className="col-md-4 mb-3">
                  <div className="bg-light border rounded p-4">
                    <h4 className="fw-bold mb-2 text-dark">NORTH</h4>
                    <p className="mb-0 text-muted">Northern Region<br/>Participants</p>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="bg-light border rounded p-4">
                    <h4 className="fw-bold mb-2 text-dark">CENTRAL</h4>
                    <p className="mb-0 text-muted">Central Region<br/>Participants</p>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="bg-light border rounded p-4">
                    <h4 className="fw-bold mb-2 text-dark">SOUTH</h4>
                    <p className="mb-0 text-muted">Southern Region<br/>Participants</p>
                  </div>
                </div>
              </div>
              <div className="text-center mt-3">
                <small className="text-muted">Points given based on how many people in each group, plus extra points for everyone</small>
              </div>
            </div>
          </div>

          {/* Important Dates */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light">
              <h3 className="card-title mb-0 text-center" style={{ color: '#0b3d91' }}>
                📅 Important Dates
              </h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <div className="d-flex align-items-center p-3 bg-light border rounded">
                    <div className="flex-shrink-0 me-3">
                      <div className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                        <i className="bi bi-calendar-plus"></i>
                      </div>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1 text-dark">Bird Acceptance Opens</h6>
                      <p className="mb-0">March 15, 2026</p>
                      <small className="text-muted">Start taking birds</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="d-flex align-items-center p-3 bg-light border rounded">
                    <div className="flex-shrink-0 me-3">
                      <div className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                        <i className="bi bi-calendar-x"></i>
                      </div>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1 text-dark">Bird Acceptance Closes</h6>
                      <p className="mb-0">May 15, 2026</p>
                      <small className="text-muted">Last day for new birds</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="d-flex align-items-center p-3 bg-light border rounded">
                    <div className="flex-shrink-0 me-3">
                      <div className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                        <i className="bi bi-arrow-repeat"></i>
                      </div>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1 text-dark">Replace Birds By</h6>
                      <p className="mb-0">June 1, 2026</p>
                      <small className="text-muted">Last day to change birds</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Breeder's Shipping Information */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light">
              <h3 className="card-title mb-0 text-center" style={{ color: '#0b3d91' }}>
                📦 Shipping and Payment Information
              </h3>
            </div>
            <div className="card-body">
              <div className="alert alert-info mb-4">
                <i className="bi bi-info-circle-fill me-2"></i>
                <strong>Important:</strong> Birds must be sent with the Check payment payable to <strong>Central Jersey Combine</strong> and the race entry form.
                <div className="mt-2">
                  <a href="https://api.charmedcoder.com/UploadedFiles/cjccombine/posts/2026_IF Convention Entry Sheet.doc" 
                     target="_blank" 
                     rel="noopener noreferrer" 
                     className="btn btn-sm btn-primary">
                    <i className="bi bi-download me-2"></i>
                    Download Entry Form
                  </a>
                </div>
              </div>

              <div className="alert alert-success mb-4">
                <i className="bi bi-lightbulb-fill me-2"></i>
                <strong>Shipping Flexibility:</strong> You can send all your birds to any one of the locations listed below, regardless of which sections they're assigned to. If your birds are going to multiple sections, simply choose the most convenient location and send them all together - there's no need to split shipments.
              </div>

              <h5 className="mb-3 text-center">Ship Your Birds To:</h5>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="card h-100 border-primary">
                    <div className="card-body">
                      <p className="mb-2"><span className="badge bg-primary rounded-pill">North Section</span></p>
                      <p className="mb-1"><strong>Vinnie Torre</strong></p>
                      <p className="mb-1">647 Ratzer Road</p>
                      <p className="mb-0">Wayne, NJ 07470</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="card h-100 border-primary">
                    <div className="card-body">
                      <p className="mb-2"><span className="badge bg-primary rounded-pill">Central Section</span></p>
                      <p className="mb-1"><strong>Bill Daniele</strong></p>
                      <p className="mb-1">78 E. Oak St.</p>
                      <p className="mb-0">Carteret, N.J. 07708</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="card h-100 border-primary">
                    <div className="card-body">
                      <p className="mb-2"><span className="badge bg-primary rounded-pill">South Section</span></p>
                      <p className="mb-1"><strong>Stanley Krawiec</strong></p>
                      <p className="mb-1">4 Villanova Drive</p>
                      <p className="mb-0">Manalapan, N.J. 07726</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="card h-100 border-primary">
                    <div className="card-body">
                      <p className="mb-2"><span className="badge bg-primary rounded-pill">Staten Island</span></p>
                      <p className="mb-1"><strong>Charlies Aiosa</strong></p>
                      <p className="mb-1">357 McClean St.</p>
                      <p className="mb-0">Staten Island, N.Y. 10305</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Who Can Participate? */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light">
              <h3 className="card-title mb-0 text-center" style={{ color: '#0b3d91' }}>
                👥 Who Can Participate?
              </h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <h5 className="text-success mb-3">
                    <i className="bi bi-check-circle-fill me-2"></i>
                    For Handlers
                  </h5>
                  <ul className="list-unstyled">
                    <li className="mb-2 d-flex align-items-start">
                      <i className="bi bi-arrow-right-circle-fill text-success me-2 mt-1"></i>
                      <span>Must be 2026 IF and CJC member in good standing</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <i className="bi bi-arrow-right-circle-fill text-success me-2 mt-1"></i>
                      <span>Must live in New Jersey or Staten Island</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <i className="bi bi-arrow-right-circle-fill text-success me-2 mt-1"></i>
                      <span>Must race at least 5 birds</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <i className="bi bi-x-circle-fill text-danger me-2 mt-1"></i>
                      <span><strong>Cannot race your own birds</strong></span>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6 mb-4">
                  <h5 className="text-primary mb-3">
                    <i className="bi bi-heart-fill me-2"></i>
                    For Breeders
                  </h5>
                  <ul className="list-unstyled">
                    <li className="mb-2 d-flex align-items-start">
                      <i className="bi bi-arrow-right-circle-fill text-primary me-2 mt-1"></i>
                      <span>Open to all pigeon breeders</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <i className="bi bi-arrow-right-circle-fill text-primary me-2 mt-1"></i>
                      <span>You can select your handlers or we can assign them to you</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <i className="bi bi-arrow-right-circle-fill text-primary me-2 mt-1"></i>
                      <span>Maximum 5 birds per handler (No bird limit just need to select different handlers)</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <i className="bi bi-arrow-right-circle-fill text-primary me-2 mt-1"></i>
                      <span>Payment MUST accompany birds – Payable to the Central Jersey Combine. </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Race Rules */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light">
              <h3 className="card-title mb-0 text-center" style={{ color: '#0b3d91' }}>
                📖 Race Rules
              </h3>
            </div>
            <div className="card-body">
              <ul className="list-unstyled">
                <li className="mb-3 d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                  <span>Birds not assigned  to a specific handler will be assigned out randomly by the Central Jersey Combine</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                  <span>All races follow CJC (Central Jersey Combine) rules</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                  <span>Weather conditions determine final race schedule</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                  <span>Top 25 birds will be auctioned after the race</span>
                </li>
              </ul>
            </div>
          </div>

          {/* <div className="card mb-4">
            <div className="card-body text-center">
              <h3 className="card-title">Event Highlights</h3>
              <ul className="list-unstyled d-flex justify-content-center gap-5">
                <li className="mb-2">👋 Meet and Greet And Shipping Night</li>
                <li className="mb-2">🏆 Race Day</li>
                <li className="mb-2">💎 Auction Day</li>
              </ul>
            </div>
          </div> */}

          <div className="card">
            <div className="card-body text-center">
              <h3 className="card-title mb-4" style={{ color: '#0b3d91' }}>Ready to Join?</h3>
              <p className="mb-4">
                Sign up for the 2026 IF Convention Race as a handler or breeder.
              </p>
              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <a href="/race/participants" className="btn btn-outline-primary">
                  <i className="bi bi-people me-2"></i>
                  View Participants
                </a>
                <a href="/race/signup" className="btn btn-primary">
                  <i className="bi bi-person-plus me-2"></i>
                  Register Now
                </a>
                <a href="/race" className="btn btn-outline-secondary">
                  <i className="bi bi-arrow-left me-2"></i>
                  Back to Landing Page
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}